import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { map, Observable } from 'rxjs';
import { UserService } from '@/service/user.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private readonly userService: UserService,
    private readonly router: Router
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {

    return this.userService.currentUser.pipe(
      map((user) => {
        if (user) {
          if (user.accountType == route.data['roles']) {
            if(['/user'].includes(state.url)){
              return this.router.parseUrl(`/user/${user.id}`);
            }
            return true;
          } else {
            return this.router.parseUrl('/404');
          }
        } else {
          this.userService.redirectUrl = state.url;
          return this.router.parseUrl('/login');
        }
      })
    );
  }
}
